<!-- 城管 -->

<template>
    <MainLayout :class="splitEnabled ? 'mar-top-8' : ''" style="height: calc(100% - 16px); padding: 0px 8px"
        leftWidth="320px" rightWidth="320px" :hasLeft="!splitEnabled" :hasRight="!splitEnabled"
        :hasHeader="!splitEnabled" @toggleRight="handleToggleRight">
        <News slot="header"> </News>
        <!-- 左侧 -->
        <LeftAside slot="left" :searchForm="searchForm" :tabControlList="tabControlList" :onPictureData="onPictureData"
            @checkGrid="handleCheckGrid" @checkZhengShe="handleCheckZhengShe"
            @zhengSheDingweiClick="handleZhengSheDingweiClick" :onZhengSheData="onZhengSheData"
            :onEventData="onLeftEventData" @eventListClick="handleEventListClick" />
        <LeftAside slot="left" :searchForm="searchForm" :tabControlList="tabControlList" :onPictureData="onPictureData"
            @checkGrid="handleCheckGrid" @checkZhengShe="handleCheckZhengShe"
            @zhengSheDingweiClick="handleZhengSheDingweiClick" :onZhengSheData="onZhengSheData"
            :onEventData="onLeftEventData" @eventListClick="handleEventListClick" />
        <!-- 中间地图 -->
        <div ref="middlRef" slot="main" class="c-middle" style="padding: 12px">
            <MapContainer ref="mapRef" :useServiceConfigZoom="false" :zoom="12" :bottomToolConfig="bottomToolConfig"
                :leftLayers="leftLayers" :rightLayers="rightLayers" @splitEnabledChange="splitEnabledChange">
                <template slot="openlayer">
                    <!-- 网格图层 -->
                    <OpenlayerGridLayer :gridList="gridList" :queryDate="searchForm.queryDate"
                        :photoInfo="{ photoList: photoList }" :activityObj="activityObj"> </OpenlayerGridLayer>
                    <!-- 事件点 -->
                    <EventPoints v-if="eventList && eventList.length > 0" :eventList="eventList"></EventPoints>
                    <!-- 全景点位 -->
                    <PanoramaPoint layerVisible :pointList="panoramalocationList"></PanoramaPoint>
                    <!-- 网格图层勾选的正射影像图层   v-if="!splitEnabled" -->
                    <template v-if="leftAsideCheckedZhengSheList.length > 0">
                        <!-- 左侧正射列表勾选的正射影像图层 -->
                        <template v-for="item in leftAsideCheckedZhengSheList">
                            <LTile v-if="item.formatType === 'tile'" :key="item.id" :url="item.src"> </LTile>
                            <LWMSTile :ref="`${item.id}`" v-else-if="item.formatType === 'wms'" :key="item.id"
                                :baseUrl="item.src" :params="item.params" :projection="item.projection"
                                :zIndex="item.zIndex">
                            </LWMSTile>
                        </template>
                    </template>
                </template>
                <template slot="legend">
                    <!-- 图例 -->
                    <div class="flex-align-center legend-center" v-for="(item, index) in mapLegendList" :key="index">
                        <div class="legend-icon" :style="item.style">{{ item.value }}</div>
                        <div>{{ item.label }}</div>
                    </div>
                </template>
            </MapContainer>
            <!-- 对比图层下拉选择框 -->
            <div v-if="splitEnabled" class="compare-select-box">
                <div style="margin-right: 4px">
                    <el-select v-model="selectedLeftLayer" class="el-select-blue" clearable
                        popper-class="c-el-select-dropdown-blue" @change="handleSelectCompareLayerChange">
                        <el-option v-for="item in layerSelectOptions" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </div>
                <div style="margin-left: 4px">
                    <el-select v-model="selectedRightLayer" class="el-select-blue" clearable
                        popper-class="c-el-select-dropdown-blue" @change="handleSelectCompareLayerChange">
                        <el-option v-for="item in layerSelectOptions" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </div>
            </div>
            <!-- 头部类型选择 -->
            <mapTopTab v-if="!splitEnabled" :tabList="tabList" :tabControlList="tabControlList"
                :currentTab="searchForm.currentTab" @changeDataControl="changeDataControl"
                @changeTypeControl="changeTypeControl"></mapTopTab>

            <!-- 底部时间轴 -->
            <SelectYear v-if="!splitEnabled" style="bottom: 80px" @changeSelectTime="changeSelectTime"></SelectYear>
        </div>
        <!-- 右侧 -->
        <RightAside ref="rightRef" slot="right" :queryDate="searchForm.queryDate" />
    </MainLayout>
</template>

<script>
import { LTile, LWMSTile } from '@OpenLayersCommon';
import MainLayout from '@/components/layout';
import News from '@/page/mainPage/components/news/News.vue';

import mapTopTab from '@/page/business/components/mapTopTab/index.vue';
import SelectYear from '@/page/business/components/SelectYear/SelectYear.vue';

import RightAside from './components/RightAside.vue';
import LeftAside from './components/LeftAside.vue';

import MapContainer from '@/components/map/MapContainer/MapContainer.vue';
import OpenlayerGridLayer from '../components/OpenlayerGridLayer';
import EventPoints from '@/page/mainPage/mapComponents/EventPoints.vue';
import PanoramaPoint from '@/page/mainPage/mapComponents/panorama-point.vue';

import { cgControl } from '@/page/business/components/mapTabs.js';
import apiPanorama from '@/api/dataManagement/panorama';

export default {
    components: {
        MainLayout,
        News,
        LeftAside,
        RightAside,
        MapContainer,
        OpenlayerGridLayer,
        EventPoints,
        PanoramaPoint,
        LWMSTile,
        LTile,
        SelectYear,
        mapTopTab,
    },
    props: {},

    data () {
        // 计算当前日期的前一个月
        const getPrevMonth = () => {
            const now = new Date();
            const currentYear = now.getFullYear();
            const currentMonth = now.getMonth() + 1; // 当前月份（1-12）

            // 计算前一个月的年和月
            let prevYear;
            let prevMonth;
            if (currentMonth === 1) {
                // 若当前是1月，前一个月是去年12月
                prevYear = currentYear - 1;
                prevMonth = 12;
            } else {
                prevYear = currentYear;
                prevMonth = currentMonth - 1;
            }

            // 转换为selectLeftActiveMonth格式：(年份-2021)*12 + 月份

            return prevMonth;
        };

        return {
            currentLeftTab: { index: 0 },
            checkedGridGroups: [],
            eventList: [],
            photoList: [],
            panoramalocationList: [], // 全景点列表

            // 当前是否处于对比模式
            splitEnabled: false,
            selectedLeftLayer: '', // 对比模式下地图左侧图层
            selectedRightLayer: '', // 对比模式下地图右侧图层

            layerSelectOptions: [
                // {
                //     name: '高德卫星地图',
                //     id: 1,
                //     formatType: "tile",
                //     src: 'https://webst02.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}',
                //     projection: "EPSG:4326",
                // },
                // {
                //     name: '高德矢量地图',
                //     id: 2,
                //     formatType: "tile",
                //     src: 'https://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={z}',
                //     projection: "EPSG:4326",
                // },
            ],

            leftAsideCheckedZhengSheList: [],
            // 默认选中时间对象
            selectTime: {
                year: new Date().getFullYear(),
                yearLeft: new Date().getFullYear(),
                yearRight: new Date().getFullYear(),
                monthLeft: getPrevMonth(), // 默认今年1月
                monthRight: new Date().getMonth() + 1,
                dayLeft: new Date().getDate(),
                dayRight: new Date().getDate(),
            },
            searchForm: {
                queryDate: [],
                currentTab: 'grid',
                eventTypeId: '',
                eventStatus: '',
            },
            tabControlList: ['events', 'photos', 'grid', 'ortho'],
            tabList: cgControl,
            activityObj: {},
        };
    },
    computed: {
        /**
         * 底部工具栏的配置
         *
         * @returns 返回底部工具栏的配置对象
         */
        bottomToolConfig () {
            return {
                showFly: false,
                showSplit: this.searchForm.currentTab === 'ortho', // 只有在左侧选中影像列表时才显示比对按钮
            };
        },
        mapLegendList () {
            return [
                {
                    label: this.$t('chengguan.index.canFly'),
                    value: '',
                    style: {
                        color: '#ffffff',
                        backgroundColor: 'rgba(143,255,0,0.3)',
                        border: '1px solid rgba(143,255,0,0.8)',
                    },
                },
                {
                    label: this.$t('chengguan.index.cannotFly'),
                    value: '',
                    style: {
                        backgroundColor: 'rgba(255,13,71,0.3)',
                        border: '1px solid rgba(255,13,71,0.8)',
                    },
                },
                {
                    label: this.$t('chengguan.index.inspectionFrequency'),
                    value: '1',
                    style: {
                        color: '#ffffff',
                        backgroundColor: 'rgba(143,255,0,0.3)',
                        border: '1px solid rgba(143,255,0,0.8)',
                    },
                },
                {
                    label: this.$t('chengguan.index.suspectedEvent'),
                    value: '1',
                    style: {
                        color: '#ffffff',
                        backgroundColor: 'rgba(255, 0, 0, 0.7)',
                        border: '1px solid rgba(255, 0, 0, 0.8)',
                        borderRadius: '5px',
                    },
                },
            ];
        },
        gridList () {
            let list = [];
            if (Array.isArray(this.checkedGridGroups)) {
                this.checkedGridGroups.forEach((item) => {
                    if (Array.isArray(item.gridInfoList) && item.gridInfoList.length > 0) {
                        list = list.concat(item.gridInfoList);
                    }
                });
            }
            return list;
        },
        /**
         * 卷帘模式下显示在地图左侧的图层
         *
         *
         */
        leftLayers () {
            let list = this.layerSelectOptions.filter((item) => item.id == this.selectedLeftLayer);
            return list;
        },
        /**
         * 卷帘模式下显示在地图右侧的图层
         *
         *
         */
        rightLayers () {
            let list = this.layerSelectOptions.filter((item) => item.id == this.selectedRightLayer);
            return list;
        },
    },
    methods: {
        onPictureData (data) {
            this.photoList = data;
            // console.log('onPictureData============>', data);
        },

        changeDataControl (dataList) {
            // console.log('changeDataControl', dataList);

            this.tabControlList = dataList;
        },
        changeTypeControl (type) {
            // console.log('changeTypeControl', type);
            this.searchForm.currentTab = type;
        },
        // 时间选择回调函数
        changeSelectTime (type, time) {
            // console.log('changeSelectTime', type, time);

            if (type === 'year') {
                this.selectTime.year = time;
            }
            if (type === 'times') {
                Object.assign(this.selectTime, time.Lefttimes, time.Righttimes);
            }
            this.searchForm.queryDate = [
                `${this.selectTime.yearLeft}-${this.selectTime.monthLeft}-${this.selectTime.dayLeft} 00:00:00`,
                `${this.selectTime.yearRight}-${this.selectTime.monthRight}-${this.selectTime.dayRight} 23:59:59`,
            ];
        },

        /**
         * @description 勾选网格分组
         * @param {*} data
         */
        handleCheckGrid (data) {
            this.checkedGridGroups = data || [];
        },
        /**
         *左侧选择正射影像列表勾选事件处理函数
         *
         * @param data 触发事件时传递的数据
         */
        handleCheckZhengShe (data) {
            this.leftAsideCheckedZhengSheList = data || [];
        },
        /**
         * 处理左侧正射列表点击定位图标的事件，定位到正射合适的视图范围
         */
        handleZhengSheDingweiClick (data) {
            if (data.bbox) {
                this.$refs.mapRef.fitExtent(data.bbox);
            }
        },

        /**
         * 处理事件列表点击事件
         *
         * @param data 事件数据对象
         */
        handleEventListClick (data) {
            const { longitude, latitude, id } = data;
            this.activityObj = data;
            if (longitude && latitude) {
                this.toMapCenter([longitude, latitude]);
            }
        },
        /**
         * 将地图中心点移动到指定位置
         *
         * @param center 地图中心点坐标，格式为 [经度, 纬度]
         */
        toMapCenter (center) {
            if (this.$refs.mapRef) {
                this.$refs.mapRef.toCenter(center);
            }
        },
        splitEnabledChange (data) {
            this.splitEnabled = data;
        },
        // 左侧查询到的正射影像数据时触发，参数是正射影像数据列表
        onZhengSheData (data) {
            // console.log(data);
            if (data) {
                let list = JSON.parse(JSON.stringify(data));
                list.forEach((item) => {
                    item.zIndex = 100;
                });
                this.layerSelectOptions = list;
            }
        },
        /**
         * 处理左侧事件列表
         *
         * @param data 触发事件时传递的数据
         * */
        onLeftEventData (data) {
            this.eventList = data || [];
        },
        /**
         * 右侧面板展开收起事件，展开时resize一下统计图表
         */
        handleToggleRight (visible) {
            if (visible) {
                setTimeout(() => {
                    this.$refs.rightRef && this.$refs.rightRef.resizeChart();
                }, 200);
            }
        },
        /**
        * 处理选择对比层变化的方法
        *
        * @param value - 对比层变化后的值
        */
        handleSelectCompareLayerChange (value) {
            if (value) {
                let target = this.layerSelectOptions.find((item) => item.id == value);
                if (target) {
                    if (this.$refs.mapRef && target.bbox) {
                        this.$refs.mapRef.fitExtent(target.bbox);
                    }
                }
            }
        },
        async getPanoramaLocationList() {
            let { data } = await apiPanorama.getPanoramaLocationList();
            this.panoramalocationList = data;
        },
    },
    mounted () {
        this.getPanoramaLocationList();
    },
    provide () {
        return {
            selectTime: this.selectTime, // 可传递响应式数据
        };
    },
};
</script>

<style lang="scss" scoped>
.mar-top-8 {
    margin-top: 8px;
}

.c-middle {
    width: 100%;
    height: 100%;

    .compare-select-box {
        position: absolute;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 9999;
        display: flex;

        ::v-deep .el-select-blue {
            .el-input__inner {
                background-color: #071150;
            }
        }
    }

}

//用来切换后保存时间的东东
.hiddenSelectYear {
    visibility: hidden;
}
</style>

<style lang="scss">
.legend-center {
    margin:0 0 10px 10px ;
    float: left;

    .legend-icon {
        display: inline-block;
        width: 14px;
        height: 14px;
        font-size: 10px;
        align-items: center;
        justify-content: center;
        margin-right: 4px;
        text-align: center;
    }
}
</style>
